import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Modal, ModalWrapper, ModalHeader, ModalContent, ModalFooter, ModalBackdrop
} from '@workboard/wobo-ui';
import styled from 'styled-components';
import ConfirmModal from '../../styled-base/modal/implementations/confirm-modal';

const StyledModal = styled(Modal)`
  ${ModalWrapper} {
    width: 400px;
    border-radius: 4px;
  }
  ${ModalHeader} {
    padding: 10px 20px !important;
    h1 {
        font-size: 1.15em;
    }
  }
  ${ModalContent} {
    padding: 10px 20px !important;
    p {
       line-height: 1.5;
        margin: 0;
    }
  }
  ${ModalFooter}{
    padding: 15px 20px !important;
  }
  ${ModalBackdrop}{
    background-color: rgba(0,0,0,0.15) !important;
  }
`;

type CommentDeleteProps = {
    onClose: () => void,
    onYes: () => void
}
export default function CommentDeleteDialog ({ onClose, onYes }: CommentDeleteProps) {
  const { t } = useTranslation();
    return (
        <StyledModal
            className="comment-delete-conform"
            title={t('Delete Comment')}
            isOpen
            onDismiss={onClose}
            onSubmit={onYes}
            submitLabel= {t('Delete')}
            data-testid="comment-delete-conform-testid"
        >
            <p>
                {t('Are you sure you want to delete this comment? This cannot be undone')+'.'}
            </p>
        </StyledModal>
    );
}
